module.exports = ReactHelmet;